import { createContext } from "react";

import { IContextSupportMessenger } from "./support_messenger.types";

export const ContextSupportMessenger = createContext<IContextSupportMessenger>(
  null as unknown as IContextSupportMessenger,
);

ContextSupportMessenger.displayName = "ContextSupportMessenger";
